import { useMutation } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import Api from '@app/services/api';

export const useGetImportState = () => {
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async (uid: string) => {
      return await Api.orders.getImportState(uid);
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: async (data) => {
      return data;
    },
  });
};
